import dayjs from 'dayjs'
import 'dayjs/locale/es'

/**
 * Instancia de dayjs configurada con locale es-MX.
 */
dayjs.locale('es')
export default dayjs
